/** Razorpay Checkout helper. Loads the CDN script once, then opens the modal. */
let scriptPromise = null;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return scriptPromise;
}

export async function openRazorpay({ order, onSuccess, onFailure, onDismiss, prefill }) {
  const ok = await loadRazorpay();
  if (!ok) { onFailure?.(new Error("Could not load Razorpay Checkout.")); return; }
  const rz = new window.Razorpay({
    key: order.key_id, amount: order.amount, currency: order.currency,
    order_id: order.order_id,
    name: order.company_name || "PlumberHQ",
    description: order.description || "PlumberHQ subscription",
    prefill: prefill || {},
    theme: { color: "#2563EB" },
    handler: async (resp) => {
      try { await onSuccess?.(resp); } catch (e) { onFailure?.(e); }
    },
    modal: { ondismiss: () => onDismiss?.() },
  });
  rz.on?.("payment.failed", (resp) => onFailure?.(resp.error || new Error("Payment failed")));
  rz.open();
}
